import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import fr from 'vuetify/es5/locale/fr'
import en from 'vuetify/es5/locale/en'

import theme from '@/config/theme'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { en, fr },
    current: 'fr'
  },
  theme: {
    themes: {
      light: {
        ...theme
      }
    }
  }
})
